import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import { prefixCls, iconPrefixCls } from '@/constants';
import moment from 'moment';
// import 'moment/locale/zh-cn';
import '@/common/utils/moment-zh';
// import { useConfig } from '@/apis/ducc';

moment.locale('zh-cn');

ConfigProvider.config({
  prefixCls: prefixCls,
  iconPrefixCls: iconPrefixCls,
});

const AcoreConfigProvider = ({ children }) => {
  return (
    <ConfigProvider prefixCls={prefixCls} iconPrefixCls={iconPrefixCls} locale={zhCN}>
      {children}
    </ConfigProvider>
  );
};

export default AcoreConfigProvider;
